import { kpiApi } from "@/api/kpiApi";
import { Button, Card, CardContent, CardHeader, Container, Divider, Stack } from "@mui/material";
import { Form, FormikProvider, useFormik } from "formik";
import { useNavigate, useOutletContext } from "react-router-dom";
import KpiInformationForm, { initialValues, validationSchema } from "./KpiInformationForm";

export default function KpiCreateNew(props) {
    const { kpiOptions } = useOutletContext();
    const navigate = useNavigate();
    const [createNewKpi] = kpiApi.endpoints.createNewKpi.useMutation();
    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                setSubmitting(true);
                const response = await createNewKpi({ data: values }).unwrap();
                const kpiId = response.data?.id;
                setSubmitting(false);
                navigate(`/kpis/${kpiId}`, { replace: true });
            } catch (error) {
                console.error(error);
            }
            setSubmitting(false);
        },
    });

    return (
        <Container>
            <Card>
                <CardHeader title="ข้อมูลทั่วไป"></CardHeader>
                <Divider variant="middle" />
                <CardContent>
                    <FormikProvider value={formik}>
                        <Form>
                            <KpiInformationForm
                                typeOptions={kpiOptions?.kpiTypes}
                                timeframeOptions={kpiOptions?.timeframes}
                            />
                            <Stack direction="row" spacing={1} sx={{ marginTop: 3 }}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    disabled={formik.isSubmitting || !formik.dirty}
                                >
                                    บันทึก
                                </Button>
                                <Button type="reset" disabled={formik.isSubmitting}>
                                    ยกเลิก
                                </Button>
                            </Stack>
                        </Form>
                    </FormikProvider>
                </CardContent>
            </Card>
        </Container>
    );
}
